import React from 'react';
import PropTypes from 'prop-types';

function OButton({ active, activeColor, color }) {
  return (
    <>
      <path
        d="M673.273 214.34C673.273 225.614 664.134 234.754 652.858 234.754C641.582 234.754 632.443 225.614 632.443 214.34C632.443 203.064 641.582 193.924 652.858 193.924C664.134 193.924 673.273 203.064 673.273 214.34Z"
        fill={active ? activeColor : color}
      />
      <path
        d="M666.215 214.34C666.215 221.716 660.235 227.695 652.858 227.695C645.481 227.695 639.502 221.716 639.502 214.34C639.502 206.963 645.481 200.984 652.858 200.984C660.235 200.984 666.215 206.963 666.215 214.34Z"
        stroke="#FFA14D"
        strokeWidth="4"
        strokeMiterlimit="10"
      />
    </>
  );
}

OButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

OButton.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#464A56',
};

export default OButton;
